import api from './baseApi';

export function getProjectsByUserId(userId) {
  return api.get(`/project/projectsByUserId/${userId}`);
}